import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import NutritionByIballa from './App';
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<NutritionByIballa />);